module.exports = __webpack_public_path__ + "static/media/006.554c527a.jpg";